<template>
  <div class="ticket-out">
    <div class="ticket" @click="open = !open">
      <div class="meta">
        <h3>
          Option {{ rate.optionNumber }}
          <span class="option-info" v-tippy="{ position: 'top', arrow: true, inertia: true, size: 'large' }" :data-html="'#' + rateId">
            <div class="option-tooltip" :id="rateId" style="display:none;">
              <div class="tool-in">
                <div v-for="item in tableData" :class="getFontColor(item.providerQuality)"><span class="bold">{{ item.Service }}</span> - {{ item.Carrier }} [{{ item.providerQuality }}/100]</div>
              </div>
            </div>
            <i class="fa fa-info-circle"></i>
          </span>
        </h3>
      </div>
      <div class="days c">
        <h4>Days</h4>
        <p>{{ numberFormat(days) }}</p>
      </div>
      <div class="cost c">
        <h4>Total ({{ currency }})</h4>
        <p>{{ numberFormat(total) }}</p>
      </div>
      <div class="cost c">
        <h4>Quality</h4>
        <p>{{ quality }}</p>
      </div>
      <div class="expand c">
        <i :class="[ open ? 'open' : '', 'fa fa-2x fa-chevron-down but' ]"></i>
      </div>
    </div>
    <div :class="[ open ? 'open' : '', 'details' ]">
      <div class="table-responsive">
        <table class="table table-hover table-bordered">
          <thead>
          <tr>
            <th>Service</th>
            <th>From</th>
            <th>To</th>
            <th>Tariff</th>
            <th>Provider</th>
            <th>Rate ({{ currency }})</th>
            <th>Duration</th>
          </tr>
          </thead>
          <tbody>
          <tr
          v-for="(item, i) in rate.item"
          :class="[ item.details[0].rateSpecificTo ? 'special ' + item.details[0].rateSpecificTo.toLowerCase() : '' ]"
          data-toggle="tooltip"
          :title="getTooltipMessage(item)"
          >
            <td @click="openItemBreakDown(i)">
              <i class="fa fa-user-secret" v-if="item.details[0].rateSpecificTo"></i>
              {{ servicesCodeToName[item.service] }}
            </td>
            <td @click="openItemBreakDown(i)">{{ item.details[0].from }}</td>
            <td @click="openItemBreakDown(i)">{{ item.details[0].to }}</td>
            <td @click="openItemBreakDown(i)">{{ item.details[0].tariffName }}</td>
            <td @click="openItemBreakDown(i)">
              <span v-if="item.providerQuality" :class="getLabels(item.providerQuality)">
                {{ item.providerQuality }}
              </span>
              {{ item.serviceProviderName }}
            </td>
            <td @click="openItemBreakDown(i)" class="text-right">{{ numberFormat(item.baseRate) }}</td>
            <td @click="openItemBreakDown(i)">{{ durationText(item) }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="pull-right full-w-sm">
        <div @click="showNetwork" class="btn btn-primary sq full-w-sm" >
          View Route <i class="ion ion-arrow-graph-up-left"></i>
        </div>
        <div @click="chosen" class="btn btn-success sq full-w-sm" >
          Accept route <i class="fa fa-check-circle-o"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'QuoteRate',
    props: ['rate', 'index', 'currency', 'reportingCurrency', 'getQuality'],
    data () {
      return {
        open: false,
        makeQuickView: ''
      }
    },
    computed: {
      rateId () {
        return `rate-${this._uid}`
      },
      providersCodeToName () {
        return this.$store.getters['quote/providersCodeToName']
      },
      allServices () {
        return this.$store.getters['quote/allServices']
      },
      servicesCodeToName () {
        return this.allServices.reduce((val, {code, name}) => {
          val[code] = name
          return val
        }, {})
      },
      quality () {
        return this.getQuality(this.rate.item)
      },
      total () {
        return this.rate.item.reduce((total, {baseRate}) => {
          return total + baseRate
        }, 0).toFixed(2)
      },
      days () {
        return (this.rawDays + (this.hours / 24)).toFixed(2)
      },
      rawDays () {
        return this.duration('D')
      },
      hours () {
        return this.duration('H')
      },
      tableData () {
        return this.rate.item.map(a => {
          let b = {}
          b.Service = a.service || ''
          b.From = this.getProp(a, 'from')
          b.To = this.getProp(a, 'to')
          b.Carrier = a.serviceProviderName || ''
          b.Rate = a.reportingCurrencyRate || ''
          b.Duration = String(a.duration) + ' ' + a.durationType
          b.special = a.details[0].rateSpecificTo || ''
          b.providerQuality = a.providerQuality
          b.note = a.serviceNote || ''
          return b
        })
      }
    },
    methods: {
      getLabels (val) {
        let labels = 'mai-label label '
        if (val < 34) {
          labels += 'label-danger'
        } else if (val >= 34 && val < 67) {
          labels += 'label-warning'
        } else if (val >= 67) {
          labels += 'label-success'
        }
        return labels
      },
      getFontColor (val) {
        if (val < 34) {
          return 'mai-danger'
        } else if (val >= 34 && val < 67) {
          return 'mai-warning'
        } else if (val >= 67) {
          return 'mai-success'
        }
      },
      getTooltipMessage (item) {
        return item.details[0].rateSpecificTo ? `Item specific to ${item.details[0].rateSpecificTo.toLowerCase()}` : ''
      },
      getProp (item, prop) {
        return (!item.details) ? '' : (!item.details[0][prop]) ? '' : item.details[0][prop]
      },
      duration (str) {
        return this.rate.item.reduce((val, {duration, durationType}) => {
          return val + (durationType === str ? duration : 0)
        }, 0)
      },
      durationText (item) {
        if ((!item.duration || item.duration === '0')) { return 'N/A' }
        const durationType = item.durationType ? ' ' + item.durationType : ''
        return item.duration + durationType
      },
      /*
      chosen () {
        this.$emit('chosen', this.index)
      },
      openItemBreakDown (itemIndex) {
        this.$emit('item-chosen', { rateIndex: this.index, itemIndex: itemIndex })
      },
      */
      chosen () {
        this.$emit('chosen', this.rate.optionNumber)
      },
      openItemBreakDown (itemIndex) {
        this.$emit('item-chosen', { rateOptionNumber: this.rate.optionNumber, itemIndex: itemIndex })
      },
      showNetwork () {
        this.$emit('show-network-graph', this.rate.optionNumber)
      }
    },
    mounted () {
      this.makeQuickView = this.tableData.reduce((end, current) => {
        return end + `<div>${current.Service} - ${current.Carrier}</div>`
      }, '')
    }
  }
</script>

<style scoped>
  .mai-label {
    position: relative;
    bottom: 10px;
    border-radius: 25px;
  }
  tr.special {
    font-weight: bold;
  }
  tbody tr {
    cursor: pointer;
  }
  .ticket-out {
    background:#fff;
    margin: 20px;
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.53);
    transition: box-shadow 0.5s;
  }
  .ticket {
    display: flex;
    cursor: pointer;
    padding: 10px;
  }
  .ticket-out:hover {
    -webkit-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
    -moz-box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
    box-shadow: 0px 0px 23px 0px rgba(0,0,0,0.53);
  }
  .ticket .meta {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 50%;
  }
  .ticket .meta h3 {
    margin: 10px 0;
  }
  .ticket .days {
    width: 20%;
  }
  .ticket .cost {
    width: 20%;
  }
  .ticket .c {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .ticket .c > * {
    margin: 5px 0;
  }
  .c > h4 {
    font-size: 16px;
  }
  .ticket > * {
    border-right: 3px dashed #eee;
  }
  .ticket .expand {
    border: none !important;
    width: 10%;
  }
  .expand i {
    transition: transform 0.5s;
  }
  .expand i.open {
    transform: rotate(180deg);
  }
  .details {
    max-height:0;
    overflow: hidden;
    transition: max-height 0.5s;
  }
  .details hr {
    background-color: #eee;
    height: 3px;
    border: #eee;
    margin-top: 10px;
    margin-bottom: 0 !important;
  }
  .details.open {
    max-height: 1000px;
  }
  @media(max-width: 479px) {
    .c > h4, p {
      font-size: 12px !important;
    }

    i {
      font-size: 1.5em !important;
    }

    .meta > * {
      font-size: 20px !important;
    }
    .full-w-sm {
      width: 100%;
    }
    .ticket .meta {
      width: 35%;
    }
    .ticket .days {
      width: 25%;
    }
    .ticket .cost {
      width: 30%;
    }
    .option-info {
      display: none;
    }
  }
  .meta .option-info {
    position: absolute;
    animation-name: fly;
    animation-duration: 2s;
    animation-fill-mode: forwards;
  }
  .option-info .fa-plane {
    transform: rotate(45deg);
    animation: up;
    animation-duration: 0.5s;
    animation-delay: 2s;
    animation-fill-mode: forwards;
  }
  .meta h3 {
    width:92%;
    padding: 5px 0;
    border-top: 1px solid;
    border-bottom: 1px solid;
    animation-name: fadeIn;
    animation-duration: 2s;
    animation-fill-mode: forwards;
    opacity: 0;
    color: #000;
    font-weight: bold;
  }
  @keyframes fly {
    from {
      right: 92%;
    }
    to {
      right: 2%;
    }
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes up {
    from {
      transform: rotate(45deg);
    }
    to {
      transform: rotate(-45deg);
    }
  }
  /*
  .option-tooltip {
    display: none;
    position: absolute;
    background-color: #000;
    color: #fff;
    padding: 10px;
    overflow: visible;
    width: 165px;
    top:-20px;
    right: 23px;
    font-size: 10px;
    font-weight: normal;
  }
  .tool-in {
    width: 100%;
  }
  */
  .option-info:hover .option-tooltip {
    display: block;
  }
  thead {
    background-color: #428bca;
    color: #fff;
  }
  .details thead tr th {
    padding: 20px 10px;
    background-color: #eee;
    color: #000;
    font-weight: normal;
  }
  .details tbody tr td {
    padding: 20px 10px;
    background-color: #fff;
    color: #444;
  }
  .details tbody tr:last-child {
    border-bottom: 1px solid #c0c0c0;
  }
  .details .table-responsive table {
    margin-bottom: 0px !important;
  }
  .bold {
    font-weight: bold;
  }
  .mai-success {
    color: #5cb85c;
  }
  .mai-warning {
    color: #ec971f;
  }
  .mai-danger {
    color: #d9534f;
  }
</style>



// WEBPACK FOOTER //
// QuoteRate.vue?6e647813